import React, { Component } from 'react';

import {Time} from '../../util';

import Select from '../../components/select';
import Input from '../../components/input';
import DatePicker from '../../components/datepicker';
import TimeList from '../../components/timelist';

class FilterContainer extends Component {
  render() {
    const {
      handleOnStartSelect,
      handleOnEndSelect,
      handleOnKeywordChange,
      keyword,
      onStart,
      onStop,
      handleOnStartSelectTime,
      handleOnStopSelectTime
    } = this.props;
   
    return (
      <div className='container filter search'>
        <Select onSelect={this.handleOnSelect} type="log"/>
        <DatePicker.Range 
          onStartSelect={handleOnStartSelect}
          onEndSelect={handleOnEndSelect}
          defaultStartDate={Time.getPrevMonth()}
          defaultEndDate={Time.getToday()}
        />
        <TimeList.Range
          onStart={onStart}
          onStop={onStop}
          valueType="msec"
          onStartSelectTime={handleOnStartSelectTime}
          onStopSelectTime={handleOnStopSelectTime}
        />
        <Input.Search keyword={keyword}
            onChange={handleOnKeywordChange}
            onSubmit={this.props.handleOnSubmit}/>
      </div>
    );
  }
}

export default FilterContainer;


// WEBPACK FOOTER //
// ./src/containers/downloadlog/FilterContainer.js